{
	"title": "Términos y condiciones",
	"backTitle": "Atrás"
}
